module.exports = __webpack_public_path__ + "media/images/pdf/logo-2b7db164b6921528d174593c66aa700d.png";